// Single source of truth for print methods (mirrors backend/print_method_defs.py).
// Used by the Quote Builder selector and the Pricing Tables display-name editor
// so the two lists can never drift apart again.

export const PRINT_METHOD_DEFINITIONS = [
  { methodKey: "UltraColour Max", pricingTableKey: "ultracolour_max", defaultDisplayName: "DTF Transfer" },
  { methodKey: "UltraColour Pro", pricingTableKey: "ultracolour_pro", defaultDisplayName: "Hybrid Transfer" },
  { methodKey: "UltraColour Reflective", pricingTableKey: "ultracolour_reflective", defaultDisplayName: "Reflective Screen Transfer" },
  { methodKey: "Screen Print Pro", pricingTableKey: "screen_print_pro_sheet", defaultDisplayName: "Screen Print Transfer" },
  { methodKey: "Traditional Screen Print", pricingTableKey: "traditional_screen_print_matrix", defaultDisplayName: "Screen Print" },
  { methodKey: "Embroidery", pricingTableKey: "embroidery_tier", defaultDisplayName: "Embroidery" },
  { methodKey: "DTG", pricingTableKey: "dtg", defaultDisplayName: "DTG" },
  { methodKey: "Manual Override", pricingTableKey: null, defaultDisplayName: "Manual Override" },
];

// Ordered list of method keys for the Quote Builder print-method selector.
export const PRINT_METHODS = PRINT_METHOD_DEFINITIONS.map((d) => d.methodKey);

// pricingTableKey -> method definition (only method-backed tables).
export const METHOD_BY_TABLE = PRINT_METHOD_DEFINITIONS.reduce((acc, d) => {
  if (d.pricingTableKey) acc[d.pricingTableKey] = d;
  return acc;
}, {});
